import UserStar from "./user-star.svg";
import UserActivity from "./user-activity.svg";
import Clipboard from "./clipboard.svg";
import Brain from "./brain.svg";
import Star from "./star.svg";
import Fire from "./fire.svg";
import Clock from "./clock.svg";
import RullerIcon from "./ruller.svg";
import DnrIcon from "./dnr.svg";
import Eye from "./eye.svg";
import Energy from "./energyBar.svg";
import Midi from "./midi.svg";
import warning from "./warning.svg";
import Lighting from "./lightning.svg";
import ApplePay from "./applePay.svg";
import GooglePay from "./googlePay.svg";
import ManageProtection, { ManageProtectionV2 } from "./manage-protection.tsx";
import Visa from "./visa.svg";
import Mastercard from "./mastercard.svg";
import Medication from "./medication.svg";
import Amex from "./amex.svg";
import Discover from "./discover.svg";
import MinusCircle from "./MinusCircle.tsx";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import MicroscopeDark from "./microscope_dark.svg";
import UserFeedback from "./user-feedback.svg";
import { FC } from "react";
import { X } from "lucide-react";
import clockLightIcon from "./clock_light.svg";
import dataAnalyticsIcon from "./data-analytics.svg";
import moneyIcon from "./money.svg";
import applePodcast from "./applePodcast.svg";
import AssemblyClusterIcon from "./assembly-cluster.svg";
import Gift from "./gift.svg";

const GreenCircledCheckmark = ({ size = 32 }) => (
  <CheckCircleIcon
    height={size}
    width={size}
    className="color-white bg-green aspect-square rounded-full p-0.5"
  />
);

const WarningIcon = () => <img src={warning} className="w-[18px]" />;

export const Mark: FC<{ type: "success" | "warn" | "error" }> = ({ type }) => {
  const className =
    "h-[28px] w-[28px] min-w-[28px] flex mx-auto justify-center items-center bg-green text-white rounded-[8px]";

  if (type === "warn") {
    return (
      <div className={`${className} bg-yellow`}>
        <WarningIcon />
      </div>
    );
  } else if (type === "error") {
    return (
      <div className={`${className} bg-red-200`}>
        <X />
      </div>
    );
  } else
    return (
      //success
      <div className={`${className} bg-green`}>
        <Icons.Checkmark className="stroke-green" />
      </div>
    );
};

export const Checkmark: FC<{ className?: string }> = ({ className }) => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.6663 10.1837L1.82447 6.34183L0.174805 7.9915L5.6663 13.483L16.9911 2.15817L15.3415 0.508499L5.6663 10.1837Z"
      fill="currentColor"
    />
  </svg>
);

const Youtube = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    x="0px"
    y="0px"
    width="40px"
    height="40px"
    viewBox="0 0 24 24"
    enable-background="new 0 0 24 24"
    focusable="false"
    aria-hidden="true"
  >
    <g>
      <path
        fill="var(--color-primary)"
        d="M21.58,7.19c-0.23-0.86-0.91-1.54-1.77-1.77C18.25,5,12,5,12,5S5.75,5,4.19,5.42   C3.33,5.65,2.65,6.33,2.42,7.19C2,8.75,2,12,2,12s0,3.25,0.42,4.81c0.23,0.86,0.91,1.54,1.77,1.77C5.75,19,12,19,12,19   s6.25,0,7.81-0.42c0.86-0.23,1.54-0.91,1.77-1.77C22,15.25,22,12,22,12S22,8.75,21.58,7.19z"
      ></path>
      <polygon fill="#FFFFFF" points="10,15 15,12 10,9  "></polygon>
    </g>
  </svg>
);

const Spotify = () => (
  <svg
    role="img"
    viewBox="0 0 24 24"
    aria-label="Spotify"
    aria-hidden="false"
    height="26px"
    data-encore-id="logoSpotify"
  >
    <path
      fill="var(--color-primary)"
      d="M13.427.01C6.805-.253 1.224 4.902.961 11.524.698 18.147 5.853 23.728 12.476 23.99c6.622.263 12.203-4.892 12.466-11.514S20.049.272 13.427.01m5.066 17.579a.717.717 0 0 1-.977.268 14.4 14.4 0 0 0-5.138-1.747 14.4 14.4 0 0 0-5.42.263.717.717 0 0 1-.338-1.392c1.95-.474 3.955-.571 5.958-.29 2.003.282 3.903.928 5.647 1.92a.717.717 0 0 1 .268.978m1.577-3.15a.93.93 0 0 1-1.262.376 17.7 17.7 0 0 0-5.972-1.96 17.7 17.7 0 0 0-6.281.238.93.93 0 0 1-1.11-.71.93.93 0 0 1 .71-1.11 19.5 19.5 0 0 1 6.94-.262 19.5 19.5 0 0 1 6.599 2.165c.452.245.62.81.376 1.263m1.748-3.551a1.147 1.147 0 0 1-1.546.488 21.4 21.4 0 0 0-6.918-2.208 21.4 21.4 0 0 0-7.259.215 1.146 1.146 0 0 1-.456-2.246 23.7 23.7 0 0 1 8.034-.24 23.7 23.7 0 0 1 7.657 2.445c.561.292.78.984.488 1.546m13.612-.036-.832-.247c-1.67-.495-2.14-.681-2.14-1.353 0-.637.708-1.327 2.264-1.327 1.539 0 2.839.752 3.51 1.31.116.096.24.052.24-.098V6.935c0-.097-.027-.15-.098-.203-.83-.62-2.272-1.07-3.723-1.07-2.953 0-4.722 1.68-4.722 3.59 0 2.157 1.371 2.91 3.626 3.546l.973.274c1.689.478 1.998.902 1.998 1.556 0 1.097-.831 1.433-2.07 1.433-1.556 0-3.457-.911-4.35-2.025-.08-.098-.177-.053-.177.062v2.423c0 .097.01.141.08.22.743.814 2.52 1.53 4.59 1.53 2.546 0 4.456-1.485 4.456-3.784 0-1.787-1.052-2.865-3.625-3.635m10.107-1.76c-1.68 0-2.653 1.026-3.219 2.052V9.376c0-.08-.044-.124-.124-.124h-2.22c-.079 0-.123.044-.123.124V20.72c0 .08.044.124.124.124h2.22c.079 0 .123-.044.123-.124v-4.536c.566 1.025 1.521 2.034 3.237 2.034 2.264 0 3.89-1.955 3.89-4.581s-1.644-4.545-3.908-4.545m-.654 6.986c-1.185 0-2.211-1.167-2.618-2.458.407-1.362 1.344-2.405 2.618-2.405 1.211 0 2.051.92 2.051 2.423s-.84 2.44-2.051 2.44m40.633-6.826h-2.264c-.08 0-.115.017-.15.097l-2.282 5.483-2.29-5.483c-.035-.08-.07-.097-.15-.097h-3.661v-.584c0-.955.645-1.397 1.476-1.397.496 0 1.035.256 1.415.486.089.053.15-.008.115-.088l-.796-1.901a.26.26 0 0 0-.124-.133c-.389-.203-1.025-.38-1.644-.38-1.875 0-2.954 1.432-2.954 3.254v.743h-1.503c-.08 0-.124.044-.124.124v1.768c0 .08.044.124.124.124h1.503v6.668c0 .08.044.123.124.123h2.264c.08 0 .124-.044.124-.123v-6.668h1.936l2.812 6.11-1.512 3.325c-.044.098.009.142.097.142h2.414c.08 0 .116-.018.15-.097l4.997-11.355c.035-.08-.009-.141-.097-.141M54.964 9.04c-2.865 0-4.837 2.025-4.837 4.616 0 2.573 1.971 4.616 4.837 4.616 2.856 0 4.846-2.043 4.846-4.616 0-2.591-1.99-4.616-4.846-4.616m.008 7.065c-1.37 0-2.343-1.043-2.343-2.45 0-1.405.973-2.449 2.343-2.449 1.362 0 2.335 1.043 2.335 2.45 0 1.406-.973 2.45-2.335 2.45m33.541-6.334a1.24 1.24 0 0 0-.483-.471 1.4 1.4 0 0 0-.693-.17q-.384 0-.693.17a1.24 1.24 0 0 0-.484.471q-.174.302-.174.681 0 .375.174.677.175.3.484.471t.693.17.693-.17.483-.471.175-.676q0-.38-.175-.682m-.211 1.247a1 1 0 0 1-.394.39 1.15 1.15 0 0 1-.571.14 1.16 1.16 0 0 1-.576-.14 1 1 0 0 1-.391-.39 1.14 1.14 0 0 1-.14-.566q0-.316.14-.562t.391-.388.576-.14q.32 0 .57.14.253.141.395.39t.142.565q0 .312-.142.56m-19.835-5.78c-.85 0-1.468.6-1.468 1.396s.619 1.397 1.468 1.397c.866 0 1.485-.6 1.485-1.397 0-.796-.619-1.397-1.485-1.397m19.329 5.19a.31.31 0 0 0 .134-.262q0-.168-.132-.266-.132-.099-.381-.099h-.588v1.229h.284v-.489h.154l.374.489h.35l-.41-.518a.5.5 0 0 0 .215-.084m-.424-.109h-.26v-.3h.27q.12 0 .184.036a.12.12 0 0 1 .065.116.12.12 0 0 1-.067.111.4.4 0 0 1-.192.037M69.607 9.252h-2.263c-.08 0-.124.044-.124.124v8.56c0 .08.044.123.124.123h2.263c.08 0 .124-.044.124-.123v-8.56c0-.08-.044-.124-.124-.124m-3.333 6.605a2.1 2.1 0 0 1-1.053.257c-.725 0-1.185-.425-1.185-1.362v-3.484h2.211c.08 0 .124-.044.124-.124V9.376c0-.08-.044-.124-.124-.124h-2.21V6.944c0-.097-.063-.15-.15-.08l-3.954 3.113c-.053.044-.07.088-.07.16v1.007c0 .08.044.124.123.124h1.539v3.855c0 2.087 1.203 3.06 2.918 3.06.743 0 1.46-.194 1.884-.442.062-.035.07-.07.07-.133v-1.68c0-.088-.044-.115-.123-.07"
      transform="translate(-0.95,0)"
    ></path>
  </svg>
);

const ApplePodcast = () => (
  <img src={applePodcast} alt="apple podcast" className="max-w-[28px]" />
);

const FireIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    width="34"
    height="43"
    viewBox="0 0 34 43"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.2671 21.5652C30.8277 20.52 30.3286 19.3359 29.8407 17.874C28.5646 14.0472 32.6418 9.873 32.6806 9.83423L30.3964 7.55008C30.1703 7.77623 24.867 13.1684 26.7747 18.8949C27.3013 20.4748 27.828 21.7218 28.29 22.8203C29.3669 24.9507 29.9265 27.305 29.9231 29.6922C29.7338 31.6164 28.995 33.4456 27.7949 34.9616C26.5949 36.4776 24.9841 37.6165 23.1547 38.2424C23.7326 35.9771 23.724 33.6019 23.1296 31.3409C22.5352 29.0799 21.3747 27.0075 19.7575 25.3193L18.071 23.6329L17.1309 25.8249C14.165 32.7452 10.6354 35.766 8.55965 37.026C7.28501 36.246 6.2139 35.1743 5.43454 33.8993C4.65519 32.6242 4.18989 31.1823 4.07696 29.6922C4.18739 27.6585 4.69733 25.6665 5.57765 23.8299C6.62192 21.6161 7.21028 19.2149 7.30773 16.7691V13.8969C8.71958 14.4785 10.5385 16.0018 10.5385 19.9998V24.2063L13.3541 21.0805C18.3812 15.501 17.3328 8.85693 15.3023 4.42916C16.8458 4.94365 18.1712 5.96259 19.0652 7.32193C19.9592 8.68126 20.3698 10.3019 20.2308 11.9229H23.4616C23.4616 2.97854 16.0647 0.615234 12.1539 0.615234H8.92311L10.8616 3.19823C11.0829 3.49708 15.4848 9.54185 13.0472 15.6173C12.5053 14.0902 11.5114 12.7642 10.1976 11.8157C8.88381 10.8673 7.3124 10.3412 5.69235 10.3075H4.07696V16.7691C3.96653 18.8027 3.4566 20.7947 2.57627 22.6313C1.532 24.8451 0.943639 27.2463 0.846191 29.6922C0.846191 35.9082 7.02181 42.6152 17 42.6152C26.9783 42.6152 33.1539 35.9082 33.1539 29.6922C33.155 26.8745 32.5095 24.0941 31.2671 21.5652ZM11.8873 38.6188C14.8672 36.1521 17.2743 33.0663 18.9417 29.5758C19.8326 31.0129 20.3388 32.655 20.4115 34.3443C20.4842 36.0335 20.121 37.713 19.3569 39.2213C18.5758 39.3279 17.7884 39.3824 17 39.3845C15.2663 39.3972 13.5413 39.1388 11.8873 38.6188Z"
      fill="currentColor"
    />
  </svg>
);

const BrainIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48.6153 21.1542C48.6153 18.8208 48.1557 16.5101 47.2627 14.3542C46.3697 12.1984 45.0608 10.2395 43.4108 8.5895C41.7608 6.93947 39.8019 5.6306 37.646 4.73761C35.4902 3.84462 33.1795 3.38501 30.8461 3.38501H17.923C14.0671 3.38501 10.3692 4.91674 7.64274 7.64323C4.91625 10.3697 3.38452 14.0676 3.38452 17.9235V22.7696C3.38452 24.9118 4.23548 26.9662 5.7502 28.4809C7.26491 29.9956 9.31931 30.8465 11.4614 30.8465H13.2384C13.6108 32.6709 14.602 34.3106 16.0444 35.488C17.4868 36.6655 19.2918 37.3085 21.1538 37.3081H23.383L29.8445 48.6158L32.6391 47.0004L26.1776 35.8704C25.9177 35.3466 25.5204 34.9032 25.0283 34.5874C24.5361 34.2716 23.9675 34.0953 23.383 34.0773H21.1538C19.8685 34.0773 18.6358 33.5667 17.727 32.6579C16.8182 31.7491 16.3076 30.5164 16.3076 29.2312C16.3076 27.9459 16.8182 26.7132 17.727 25.8044C18.6358 24.8956 19.8685 24.385 21.1538 24.385H22.7691V21.1542H21.1538C19.2918 21.1539 17.4868 21.7968 16.0444 22.9743C14.602 24.1518 13.6108 25.7914 13.2384 27.6158H11.4614C10.1762 27.6158 8.94353 27.1052 8.0347 26.1964C7.12587 25.2875 6.61529 24.0549 6.61529 22.7696V19.5389H9.84606C11.1313 19.5389 12.364 19.0283 13.2728 18.1194C14.1816 17.2106 14.6922 15.978 14.6922 14.6927V13.0773H11.4614V14.6927C11.4614 15.1211 11.2913 15.532 10.9883 15.835C10.6854 16.1379 10.2745 16.3081 9.84606 16.3081H6.74452C7.13264 13.6191 8.47591 11.1598 10.5286 9.37999C12.5813 7.60021 15.2062 6.61896 17.923 6.61578H27.6153V9.84655C27.6153 10.275 27.4451 10.6859 27.1422 10.9888C26.8392 11.2917 26.4283 11.4619 25.9999 11.4619H22.7691V14.6927H25.9999C27.2852 14.6927 28.5178 14.1821 29.4267 13.2733C30.3355 12.3645 30.8461 11.1318 30.8461 9.84655V6.61578C33.5503 6.61946 36.1999 7.37731 38.4971 8.80414C40.7943 10.231 42.648 12.2702 43.8499 14.6927H42.1537C40.8685 14.6927 39.6358 15.2033 38.727 16.1121C37.8182 17.0209 37.3076 18.2536 37.3076 19.5389V21.1542H40.5384V19.5389C40.5384 19.1104 40.7086 18.6995 41.0115 18.3966C41.3144 18.0937 41.7253 17.9235 42.1537 17.9235H45.013C45.26 18.9826 45.3847 20.0666 45.3845 21.1542V22.7696C45.3845 24.9118 44.5336 26.9662 43.0188 28.4809C41.5041 29.9956 39.4497 30.8465 37.3076 30.8465H32.4614V34.0773H37.3076C38.9844 34.075 40.6398 33.6998 42.1537 32.9789V34.0773C42.1537 35.3626 41.6432 36.5952 40.7343 37.5041C39.8255 38.4129 38.5929 38.9235 37.3076 38.9235H35.6922V42.1542H37.3076C39.4497 42.1542 41.5041 41.3033 43.0188 39.7886C44.5336 38.2738 45.3845 36.2194 45.3845 34.0773V30.6689C47.4519 28.5589 48.6115 25.7236 48.6153 22.7696V21.1542Z"
      fill="currentColor"
    />
  </svg>
);

const ClockIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.0002 48.6153C21.5273 48.6153 17.1548 47.2889 13.4357 44.8039C9.71664 42.3189 6.81797 38.7869 5.10627 34.6544C3.39456 30.522 2.9467 25.9748 3.81932 21.5879C4.69194 17.2009 6.84585 13.1712 10.0087 10.0084C13.1715 6.84561 17.2012 4.6917 21.5881 3.81908C25.9751 2.94646 30.5223 3.39432 34.6547 5.10603C38.7871 6.81773 42.3192 9.7164 44.8042 13.4355C47.2892 17.1546 48.6155 21.527 48.6155 25.9999C48.6155 31.9979 46.2329 37.7502 41.9916 41.9914C37.7504 46.2326 31.9981 48.6153 26.0002 48.6153ZM26.0002 6.6153C22.1662 6.6153 18.4184 7.75219 15.2306 9.8822C12.0429 12.0122 9.55829 15.0397 8.09111 18.5817C6.62394 22.1238 6.24006 26.0214 6.98801 29.7817C7.73597 33.5419 9.58218 36.9959 12.2932 39.7069C15.0042 42.4179 18.4582 44.2641 22.2184 45.0121C25.9787 45.76 29.8763 45.3761 33.4183 43.909C36.9604 42.4418 39.9879 39.9572 42.1179 36.7694C44.2479 33.5816 45.3848 29.8338 45.3848 25.9999C45.3848 20.8588 43.3425 15.9282 39.7071 12.2929C36.0718 8.6576 31.1413 6.6153 26.0002 6.6153Z"
      fill="currentColor"
    />
    <path
      d="M33.4148 35.6922L24.3848 26.6622V11.4614H27.6155V25.3214L35.6925 33.4145L33.4148 35.6922Z"
      fill="currentColor"
    />
  </svg>
);

const MicroscopeIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    width="28"
    height="33"
    viewBox="0 0 28 33"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.7355 25.8008C25.4177 24.1623 25.6005 22.3587 25.2609 20.6166C24.9214 18.8745 24.0746 17.2716 22.827 16.0092C23.1701 15.1438 23.235 14.193 23.0128 13.289C22.7906 12.3849 22.2922 11.5726 21.587 10.9648L24.7595 7.79238C25.1875 7.36327 25.4278 6.78194 25.4278 6.17587C25.4278 5.5698 25.1875 4.98847 24.7595 4.55936L21.5276 1.32749C21.3154 1.11515 21.0633 0.946708 20.786 0.831786C20.5086 0.716865 20.2113 0.657715 19.9111 0.657715C19.6109 0.657715 19.3136 0.716865 19.0362 0.831786C18.7588 0.946708 18.5068 1.11515 18.2946 1.32749L3.24145 16.3806C2.81345 16.8097 2.57309 17.3911 2.57309 17.9971C2.57309 18.6032 2.81345 19.1845 3.24145 19.6136L6.47332 22.8455C6.68558 23.0579 6.93758 23.2263 7.21495 23.3412C7.49231 23.4561 7.7896 23.5153 8.08983 23.5153C8.39006 23.5153 8.68735 23.4561 8.96472 23.3412C9.24208 23.2263 9.49409 23.0579 9.70634 22.8455L15.1633 17.3886C15.9371 18.2835 17.0326 18.8372 18.212 18.9296C19.3915 19.0221 20.5598 18.6457 21.4636 17.8823C22.404 18.9567 22.9816 20.3003 23.1144 21.7219C23.2471 23.1436 22.9282 24.5709 22.203 25.8008H13.9999V30.3721H0.286133V32.6577H27.7137V25.8008H24.7355ZM8.08926 21.2296L4.85739 17.9966L7.00473 15.8504L10.2366 19.0822L8.08926 21.2296ZM13.9999 14.3727C14.0017 14.6613 14.0307 14.949 14.0867 15.2321L11.8525 17.4663L8.62067 14.2344L19.9117 2.94343L23.1424 6.1753L19.4294 9.88944C18.7683 9.75826 18.0863 9.77576 17.4328 9.94066C16.7793 10.1056 16.1707 10.4137 15.6509 10.8429C15.1312 11.272 14.7135 11.8114 14.4279 12.4219C14.1424 13.0324 13.9962 13.6987 13.9999 14.3727ZM18.5711 16.6583C18.1191 16.6583 17.6772 16.5243 17.3013 16.2731C16.9254 16.022 16.6325 15.665 16.4595 15.2474C16.2865 14.8297 16.2412 14.3702 16.3294 13.9268C16.4176 13.4834 16.6353 13.0762 16.955 12.7565C17.2746 12.4369 17.6819 12.2192 18.1252 12.131C18.5686 12.0428 19.0282 12.0881 19.4458 12.2611C19.8635 12.4341 20.2204 12.727 20.4716 13.1029C20.7227 13.4787 20.8568 13.9206 20.8568 14.3727C20.8568 14.9789 20.616 15.5602 20.1873 15.9889C19.7587 16.4175 19.1773 16.6583 18.5711 16.6583ZM25.428 30.3721H16.2855V28.0865H25.428V30.3721Z"
      fill="currentColor"
    />
  </svg>
);

const Icons = {
  UserStar,
  UserActivity,
  Brain,
  Clipboard,
  Star,
  Midi,
  Lighting,
  ManageProtection,
  ManageProtectionV2,
  Visa,
  Clock,
  Mastercard,
  Amex,
  Discover,
  GreenCircledCheckmark,
  Checkmark,
  MinusCircle,
  MicroscopeDark,
  UserFeedback,
  Youtube,
  Spotify,
  ApplePodcast,
  ApplePay,
  GooglePay,
  Fire,
  Eye,
  Medication,
  Energy,
  AssemblyClusterIcon,
  Gift,
};

export default Icons;

export {
  RullerIcon,
  DnrIcon,
  WarningIcon,
  clockLightIcon,
  dataAnalyticsIcon,
  moneyIcon,
  FireIcon,
  ClockIcon,
  BrainIcon,
  MicroscopeIcon,
};
